import Lara from "@/presets/lara";

const checkboxIndigoPt = {
  ...Lara.checkbox,
  box: ({ context, props }) => ({
    class: [
      ...Lara.checkbox.box({ context, props }).class,
      {
        "!bg-indigo-base !border-indigo-base": context.checked,
      },
      "peer-hover:!border-indigo-base rounded-md",
    ],
  }),
  icon: {
    class: [...Lara.checkbox.icon.class],
  },
};

export const myStudentsDataTableTheme = {
  wrapper: ({ props }) => ({
    class: [
      { relative: props.scrollable, "flex flex-col grow": props.scrollable && props.scrollHeight === "flex" },

      // Size
      { "h-full": props.scrollable && props.scrollHeight === "flex" },

      // Allow rollovers
      "!overflow-visible",
    ],
  }),
  table: {
    class: "w-full border-spacing-0 border-collapse",
  },
  bodyrow: ({ context, props }) => ({
    class: [
      // Color
      "hover:bg-blue-350",
      "hover:border-blue-350",
      "border-spacing-0",
      "font-montserrat",
      "font-medium",
      "text-sm",
      "border-gray-175",
      { "bg-primary-50 text-primary-700": context.selected },
      { "bg-white text-university-primary": !context.selected },
      { "font-bold bg-surface-0": props.frozenRow },
      {
        "odd:bg-surface-0 odd:text-surface-600 dark:odd:bg-surface-800 even:bg-surface-50 even:text-surface-600 dark:even:bg-surface-900/50":
          context.stripedRows,
      },

      // State
      {
        "focus:outline-none focus:outline-offset-0 focus:ring focus:ring-primary-400/50 ring-inset dark:focus:ring-primary-300/50":
          context.selectable,
      },
      { "hover:bg-surface-300/20 hover:text-surface-600": props.selectionMode && !context.selected },

      // Transition
      { "transition duration-200": (props.selectionMode && !context.selected) || props.rowHover },

      // Misc
      { "cursor-pointer": props.selectionMode },
    ],
  }),
  column: {
    headercell: ({ context, props }) => ({
      class: [
        "font-montserrat",
        "font-semibold",
        "text-sm",
        // Position
        { "sticky z-20 border-b": props.frozen || props.frozen === "" },

        { relative: context.resizable },

        // Alignment
        "text-left",

        // Shape
        { "first:border-l border-y border-r": context?.showGridlines },
        "border-0 border-b border-solid",

        // Spacing
        context?.size === "small" ? "p-2" : context?.size === "large" ? "p-5" : "p-4",

        // Color
        (props.sortable === "" || props.sortable) && context.sorted
          ? "bg-primary-50 text-primary-700"
          : "bg-gray-125 text-surface-700",
        (props.sortable === "" || props.sortable) && context.sorted
          ? " dark:bg-primary-400/30"
          : "dark:bg-surface-800",
        "border-gray-175",

        // States
        {
          "hover:bg-surface-100 dark:hover:bg-surface-400/30":
            (props.sortable === "" || props.sortable) && !context?.sorted,
        },
        "focus-visible:outline-none focus-visible:outline-offset-0 focus-visible:ring focus-visible:ring-inset focus-visible:ring-primary-400/50 dark:focus-visible:ring-primary-300/50",

        // Transition
        { "transition duration-200": props.sortable === "" || props.sortable },

        // Misc
        { "cursor-pointer": props.sortable === "" || props.sortable },
        {
          "overflow-hidden space-nowrap border-y bg-clip-padding": context.resizable, // Resizable
        },
      ],
    }),
    bodycell: ({ props, context, state, parent }) => ({
      class: [
        //Position
        { "sticky box-border border-b": parent.instance.frozenRow },
        { "sticky box-border border-b": props.frozen || props.frozen === "" },

        // Alignment
        "text-left",

        // Shape
        "border-0 border-b border-solid",
        { "first:border-l border-r border-b": context?.showGridlines },
        { "bg-surface-0 dark:bg-surface-800": parent.instance.frozenRow || props.frozen || props.frozen === "" },

        // Spacing
        { "p-2": context?.size === "small" && !state["d_editing"] },
        { "p-5": context?.size === "large" && !state["d_editing"] },
        { "p-4": context?.size !== "large" && context?.size !== "small" && !state["d_editing"] },
        { "py-[0.6rem] px-2": state["d_editing"] },

        // Color
        "border-gray-175",
      ],
    }),
    rowCheckbox: checkboxIndigoPt,
    headerCheckbox: checkboxIndigoPt,
  },
};

export const myStudentsBulkEditButtonTheme = {
  root: {
    class: ["bg-gray-125 text-teal-900 text-sm"],
  },
};
